import { createListenerMiddleware } from "@reduxjs/toolkit"
import {
  changeColor,
  changeMode,
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changeTopbarTheme,
} from "./layoutSlice"

const layoutListener = createListenerMiddleware()

layoutListener.startListening({
  actionCreator: changeColor,
  effect: async (action, listenerApi) => {
    document.documentElement.setAttribute("data-theme-mode", action.payload)
  },
})

layoutListener.startListening({
  actionCreator: changeMode,
  effect: async (action, listenerApi) => {
    document.documentElement.setAttribute("data-bs-theme", action.payload)
  },
})

layoutListener.startListening({
  actionCreator: changeLayout,
  effect: async (action, listenerApi) => {
    document.body.setAttribute("data-layout", action.payload)
  },
})

layoutListener.startListening({
  actionCreator: changeLayoutWidth,
  effect: async (action, listenerApi) => {
    document.body.setAttribute("data-layout-size", action.payload)
  },
})

layoutListener.startListening({
  actionCreator: changeSidebarTheme,
  effect: async (action, listenerApi) => {
    document.body.setAttribute("data-sidebar", action.payload)
  },
})

layoutListener.startListening({
  actionCreator: changeTopbarTheme,
  effect: async (action, listenerApi) => {
    document.body.setAttribute("data-topbar", action.payload)
  },
})

layoutListener.startListening({
  actionCreator: changeSidebarType,
  effect: async (action, listenerApi) => {
    // Простая логика для демонстрации – её можно расширить под ваши требования
    if (action.payload.sidebarType === "compact") {
      document.body.setAttribute("data-sidebar-size", "small")
    } else if (action.payload.sidebarType === "icon") {
      document.body.setAttribute("data-keep-enlarged", "true")
    } else if (action.payload.sidebarType === "condensed") {
      document.body.classList.add("sidebar-enable")
      // Добавьте свою логику для desktop/mobile
    } else {
      document.body.removeAttribute("data-sidebar-size")
      document.body.classList.remove("vertical-collpsed")
    }
  },
})

// Экспортируем middleware, чтобы добавить его в store
export default layoutListener.middleware
